var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-shared-stars-item",class:{ 'c-shared-stars-item--visible': _vm.isVisible },style:(("--left:" + _vm.left + "%; --top:" + _vm.top + "%; --scale:" + _vm.scale))})}
var staticRenderFns = []

export { render, staticRenderFns }